module.exports = __webpack_public_path__ + "build/desktop/img/icon_point.220e1b9e34afce16c63ecc40db6a3f7e.png";